import React from 'react';
import moment from 'moment';
import { TTimesheetBooking } from './types';
import { PayRateCard } from './PayRateCard';

interface BookingCardProps {
    booking: TTimesheetBooking;
    isEditing: boolean;
    onUpdateBooking: (
        bookingId: number,
        updater: (booking: TTimesheetBooking) => TTimesheetBooking,
    ) => void;
}

export const BookingCard: React.FC<BookingCardProps> = React.memo(({
    booking,
    isEditing,
    onUpdateBooking,
}) => {
    const formattedDate = booking.date
        ? moment(booking.date).format('DD/MM/YYYY')
        : '-';

    const updateBooking = (
        field: keyof TTimesheetBooking,
        value: string | number,
    ) => {
        onUpdateBooking(booking.id, current => ({
            ...current,
            [field]: value,
        }));
    };

    return (
        <PayRateCard
            id={booking.id}
            headerPills={[
                { label: 'Job Ref', value: booking.jobReference },
                { label: 'Booking Ref', value: booking.reference_number },
                { label: 'Date', value: formattedDate },
            ]}
            values={{
                duration: booking.duration,
                payRate: booking.freelancerPayRate,
                chargeRate: booking.clientPayRate,
                code: booking.rateCode,
                description: booking.rateDescription,
            }}
            isEditing={isEditing}
            canEditCode={true}
            rateOptions={[]}
            onDurationChange={(_, value) =>
                updateBooking('duration', Number(value) || 0)
            }
            onPayChange={(_, value) =>
                updateBooking('freelancerPayRate', Number(value) || 0)
            }
            onChargeChange={(_, value) =>
                updateBooking('clientPayRate', Number(value) || 0)
            }
            onCodeChange={(_, value, name) => {
                updateBooking('rateCode', value);
                if (name) {
                    updateBooking('rateDescription', name);
                }
            }}
            onDescriptionChange={(_, value) =>
                updateBooking('rateDescription', value)
            }
        />
    );
});

BookingCard.displayName = 'BookingCard';

